<template>
    <div class="bread ">
        <ul class="ps-0 mb-0 flex-wrap">
            <li>
                <NuxtLink :to="localePath({ name: 'index' })"> Home </NuxtLink>
            </li>
            <li v-for="(crumb, index) in crumbs" :key="index">
                <span v-if="crumbs.length === (index + 1)">
                    {{ route.fullPath === crumb.path && title !== null ? title : crumb.title }}
                </span>
                <NuxtLink v-else :to="localePath(crumb.path)">
                    {{ route.fullPath === crumb.path && title !== null ? title : crumb.title }}
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script setup>

const {$country, $i18n} = useNuxtApp()
const localePath = useLocalePath()
const route = useRoute();
const router = useRouter();
const runtimeConfig = useRuntimeConfig()
const title = ref(null);
const refreshKey = ref(0);
const schema = ref([]);
const crumbs = ref([]);

useHead(() => ({
    script:  [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify(schema.value.json),
    }] ,
}))

const setBreadCrumbs = () => {
  refreshKey.value;

  let fullPath = route.path
  // const fullpath = route.path.endsWith('/')
  //   ? route.path.slice(0, -1)
  //   : route.path;

  if(route.path.endsWith('/')){
      fullPath = route.path.slice(0, -1)
  }

  if(route.path.startsWith('/in')){
    fullPath = route.path.replace('/in','')
  }
  

  const params = fullPath.startsWith('/')
    ? fullPath.substring(1).split('/')
    : fullPath.split('/');

  let path = '';

  const crumbsList = [];
  const schemaData = getBreadCrumbSchema();

  let count = 2;

  params.forEach((param, index) => {
    path = `${path}/${param}`;

    const match = router.resolve(path);

    // exclude localised index page
    if (match.name !== null && match.name !== `index___${$i18n.locale}`) {
      // set ui
      crumbsList.push({
        title: ['instock_ring___us', 'instock_pendant___us', 'instock_earring___us'].includes(route.name)
          ? param
              .replace(/-/g, ' ')  // Replace dashes with spaces
              .replace(/\b(vs1|vs2|vvs1|vvs2|si1|si2|i1|if|fl|igi|gia)\b/gi, (match) => match.toUpperCase())  // Uppercase exact clarity matches
              .replace(/(?:^|\s)(?!vs1|vs2|vvs1|vvs2|si1|si2|i1|if|fl|igi|gia)\S/g, (a) => a.toUpperCase())  // Capitalize first letters except for clarity grades
              .split(' ')  // Split into words
              .slice(0, 5)  // Take first 5 words
              .join(' ') // Join back to a string

          : param
              .replace(/-/g, ' ')  // Replace dashes with spaces
              .replace(/\b(vs1|vs2|vvs1|vvs2|si1|si2|i1|if|fl|igi|gia)\b/gi, (match) => match.toUpperCase())  // Uppercase exact clarity matches
              .replace(/(?:^|\s)(?!vs1|vs2|vvs1|vvs2|si1|si2|i1|if|fl|igi|gia)\S/g, (a) => a.toUpperCase())  // Capitalize first letters except for clarity grades
              .split(' ')  // Split into words
              .slice(0, 5)  // Take first 5 words
              .join(' '), 
        ...match,
      });
      // set schema
      schemaData.json.itemListElement.push({
        '@type': 'ListItem',
        position: count,
        name: getBreadCrumbType(match, crumbsList),
        item: `${runtimeConfig.public.domain}${match.path}`,
      });

      count++;
    }
  });

  schema.value = schemaData;
  crumbs.value = crumbsList;
};

const getBreadCrumbSchema = () => {
  let domain = runtimeConfig.public.domain;
  if ($country.isIndia) {
    domain = `${runtimeConfig.public.domain}/in`;
  }
  return {
    json: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: domain,
        },
      ],
    },
  };
};

const getBreadCrumbType = (route, crumbs) => {
  if ( route.name && route.name === `blog-listing___${$i18n.locale}`) {
    if (crumbs[0] && crumbs[1] && crumbs[2]) {
      return `${crumbs[0].title}, ${crumbs[1].title}, ${crumbs[2].title}`;
    }
    return crumbs[0].title;
  }

  if (route.name && route.name === `shop-detail___${$i18n.locale}`) {
    return crumbs[0].title;
  }

  if (route.name && route.name.includes('list')) {
    return route.params?.start_with ? crumbs[1].title : crumbs[0].title;
  }

  if (route.name && route.name.includes('detail') && route.params?.slug) {
    return crumbs[1].title;
  }

  if (crumbs[1]) {
    return crumbs[1].title || crumbs[0].title;
  }

  return crumbs[0].title;
};

  setBreadCrumbs();


  watch(route, () => {
    setBreadCrumbs();
  });
</script>


<style scoped>

    ul{
        display: flex;
        align-items: center;
    }
    ul li{
        list-style: none;
        position: relative;
        padding-right: 16px;
        min-width: max-content;
    }
    ul li a, ul li span {
        color: #212529;
        font-size: 14px;
        font-weight: 400;
    }
    ul li:after {
        position: absolute;
        content: "/";
        right: 5px;
        top: 54%;
        transform: translateY(-50%);
    }
    ul li:last-child:after {
        content: none;
    }

    @media(max-width: 767px){
        ul li a, ul li span{
            font-size: 12px;
        }
    }
    @media(max-width: 365px){
        ul li{
            padding-right: 12px;
        }
    }
</style>
